import { render, staticRenderFns } from "./InstrumentSubmit.vue?vue&type=template&id=52f25256"
import script from "./InstrumentSubmit.vue?vue&type=script&lang=ts"
export * from "./InstrumentSubmit.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentSubmit.vue?vue&type=style&index=0&id=52f25256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports